
export default {

    get(context, params, success, error) {
        context.$http.get('notifications', params).then(success, error)
    },
    
}


// WEBPACK FOOTER //
// ./src/services/notifications/index.js